// FeedbackPanel.jsx
import React from 'react';
import ReactMarkdown from 'react-markdown';
import './FeedbackPanel.css';

const FeedbackPanel = ({ feedback }) => {
  if (!feedback) return null;

  return (
    <div className="feedback-panel">
      <h2 className="feedback-title">Code Mentor's Feedback</h2>
      <div className="feedback-content">
        <ReactMarkdown>{feedback}</ReactMarkdown>
      </div>
    </div>
  );
};

export default FeedbackPanel;
